import {getEventId, getEventTitle, getFormattedFullLocation} from '@wix/wix-events-commons-statics'
import {getEvent} from '../../../../selectors/event'
import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {EventInfo as Presentation} from './event-info'
import {EventInfoOwnProps, EventInfoRuntimeProps} from './interfaces'

const mapRuntime = ({state}: DetailsPageAppProps): EventInfoRuntimeProps => {
  const event = getEvent(state)

  return {
    eventId: getEventId(event),
    title: getEventTitle(event),
    location: getFormattedFullLocation(event),
  }
}

export const EventInfo = connect<EventInfoOwnProps, EventInfoRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
